/**
 * Formats a Czech birth number (rodné číslo) as `YYMMDD/XXXX`, or `YYMMDD/XXX`
 * for the nine-digit numbers issued before 1954. Returns `''` when there is none.
 *
 * @example
 * formatBirthNumber('8506223535'); // '850622/3535'
 */
export function formatBirthNumber(birthNumber: string | undefined): string {
  if (!birthNumber) {
    return '';
  }

  return `${birthNumber.slice(0, 6)}/${birthNumber.slice(6)}`;
}
